import type { IconData } from '@stacksjs/iconify-core'

export const checkSquare: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.2 16.4a1 1 0 0 1-.707-.293l-3.2-3.2a1 1 0 0 1 1.414-1.414l2.493 2.493l6.093-6.093a1 1 0 0 1 1.414 1.414l-6.8 6.8a1 1 0 0 1-.707.293\"/><path fill=\"currentColor\" d=\"M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-3.293 7.307l-6.8 6.8a1 1 0 0 1-1.414 0l-3.2-3.2a1 1 0 0 1 1.414-1.414l2.493 2.493l6.093-6.093a1 1 0 0 1 1.414 1.414\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default checkSquare
